export const ADVISOR_NOTES_RECEIVED = 'ADVISOR_NOTES_RECEIVED'
export const ADVISOR_NOTE_CREATED = 'ADVISOR_NOTE_CREATED'
export const ADVISOR_NOTE_UPDATED = 'ADVISOR_NOTE_UPDATED'
export const ADVISOR_NOTE_DELETED = 'ADVISOR_NOTE_DELETED'
